import { render } from "./HasContentIcon.vue?vue&type=template&id=4fe4bc67&scoped=true"
import script from "./HasContentIcon.vue?vue&type=script&lang=js"
export * from "./HasContentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe4bc67"]])

export default __exports__